import React from 'react';
import { Select, Text, Box } from '@mantine/core';

const LabeledSelect = ({ 
  label, 
  placeholder, 
  value, 
  onChange, 
  data, 
  disabled = false,
  searchable = false,
  clearable = false,
  nothingFound = "검색 결과가 없습니다",
  maxDropdownHeight = 200,
  error = null,
  required = false
}) => {
  return (
    <Box>
      <Text size="md" weight={500} mb={8}>
        {label}
      </Text>
      <Select
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        data={data}
        searchable={searchable}
        clearable={clearable}
        nothingFound={nothingFound}
        maxDropdownHeight={maxDropdownHeight}
        error={error}
        required={required}
        styles={{
          input: {
            fontSize: "16px",
            height: "44px"
          },
          option: {
            fontSize: "16px",
            padding: "12px 16px"
          },
          dropdown: {
            fontSize: "16px",
            zIndex: 20000
          }
        }}
        zIndex={20000}
      />
    </Box>
  );
};

export default LabeledSelect; 